import React from "react";
import {
    FaCode,
    FaServer,
    FaDatabase,
    FaCloud
} from "react-icons/fa";
const MobileTechStack = () => {
    const technologies = [
        {
            title: "Frontend",
            items: [
                "React Native",
                "Flutter",
                "SwiftUI",
                "Jetpack Compose"
            ],
            icon: <FaCode />,
        },
        {
            title: "Backend",
            items: [
                "Node.js",
                "Laravel",
                "Firebase",
                "Supabase"
            ],
            icon: <FaServer />,
        },
        {
            title: "Database",
            items: [
                "MongoDB",
                "PostgreSQL",
                "MySQL",
                "Firestore"
            ],
            icon: <FaDatabase />,
        },
        {
            title: "Cloud & DevOps",
            items: [
                "AWS",
                "Docker",
                "Vercel",
                "CI/CD"
            ],
            icon: <FaCloud />,
        },
    ];
    return (
        <>
            <section
                style={{
                    position: "relative",
                    overflow: "hidden",
                    padding: "120px 24px",
                    background:
                        "linear-gradient(180deg,#fff 0%,#fff5f5 50%,#fff 100%)",
                }}
            >
                {/* Glow */}
                <div
                    style={{
                        position: "absolute",
                        width: "500px",
                        height: "500px",
                        borderRadius: "50%",
                        background:
                            "radial-gradient(circle, rgba(232,33,42,.10), transparent 70%)",
                        left: "-180px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        animation: "pulseGlow 8s ease-in-out infinite",
                    }}
                />

                <div
                    style={{
                        maxWidth: "1350px",
                        margin: "0 auto",
                        position: "relative",
                        zIndex: 2,
                    }}
                >
                    {/* Top */}
                    <div
                        style={{
                            textAlign: "center",
                            marginBottom: "70px",
                        }}
                    >
                        <span
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "10px",
                                background: "rgba(232,33,42,.08)",
                                border: "1px solid rgba(232,33,42,.12)",
                                padding: "10px 20px",
                                borderRadius: "999px",
                                marginBottom: "28px",
                                animation: "fadeUp .6s both",
                            }}
                        >
                            <span
                                style={{
                                    width: "8px",
                                    height: "8px",
                                    background: "#E8212A",
                                    borderRadius: "50%",
                                    animation: "pulseDot 2s infinite",
                                }}
                            />

                            <span
                                style={{
                                    fontSize: "12px",
                                    fontWeight: 700,
                                    color: "#E8212A",
                                    letterSpacing: "2px",
                                    textTransform: "uppercase",
                                    fontFamily:
                                        "'Plus Jakarta Sans',sans-serif",
                                }}
                            >
                                App Development Stack
                            </span>
                        </span>

                        <h2
                            style={{
                                fontSize: "58px",
                                lineHeight: 1,
                                color: "#111",
                                fontFamily: "'Syne',sans-serif",
                                letterSpacing: "-2px",
                                marginBottom: "24px",
                                animation: "fadeUp .8s .1s both",
                                textAlign: "center"
                            }}

                        >
                            Built With
                            <br />
                            <span
                                style={{
                                    background:
                                        "linear-gradient(135deg,#E8212A,#ff5c63)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                }}
                            >
                                Modern Technologies
                            </span>
                        </h2>

                        <p
                            style={{
                                maxWidth: "760px",
                                margin: "0 auto",
                                fontSize: "18px",
                                lineHeight: "34px",
                                color: "#666",
                                fontFamily:
                                    "'Plus Jakarta Sans',sans-serif",
                                animation: "fadeUp 1s .2s both",
                                textAlign: "center"
                            }}
                        >
                            We use industry-leading frameworks, scalable backend
                            systems, and powerful cloud infrastructure to build
                            secure, fast, and future-ready mobile applications.
                        </p>
                    </div>

                    {/* Cards */}
                    <div
                        className="tech-grid"
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(2,1fr)",
                            gap: "28px",
                        }}
                    >
                        {technologies.map((tech, index) => (
                            <div
                                key={index}
                                style={{
                                    position: "relative",
                                    background: "#fff",
                                    borderRadius: "34px",
                                    padding: "38px",
                                    border: "1px solid #f2f2f2",
                                    overflow: "hidden",
                                    boxShadow:
                                        "0 20px 60px rgba(0,0,0,.04)",
                                    transition: "all .45s ease",
                                    animation: `fadeUp ${0.6 + index * 0.15
                                        }s both`,
                                    cursor: "pointer",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform =
                                        "translateY(-14px)";
                                    e.currentTarget.style.boxShadow =
                                        "0 30px 80px rgba(232,33,42,.12)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform =
                                        "translateY(0px)";
                                    e.currentTarget.style.boxShadow =
                                        "0 20px 60px rgba(0,0,0,.04)";
                                }}
                            >
                                {/* Background Shape */}
                                <div
                                    style={{
                                        position: "absolute",
                                        width: "180px",
                                        height: "180px",
                                        borderRadius: "50%",
                                        background:
                                            "linear-gradient(135deg,rgba(232,33,42,.08),transparent)",
                                        top: "-60px",
                                        right: "-60px",
                                    }}
                                />

                                {/* Icon */}

                                <div className="technology-icon">
                                    {tech.icon}
                                </div>

                                <h3
                                    style={{
                                        fontSize: "28px",

                                        marginBottom: "24px",
                                        color: "#111",
                                        fontFamily: "'Syne',sans-serif",
                                    }}
                                >
                                    {tech.title}
                                </h3>

                                <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "14px",
                                    }}
                                >
                                    {tech.items.map((item, i) => (
                                        <div
                                            key={i}
                                            style={{
                                                padding: "12px 18px",
                                                borderRadius: "999px",
                                                background: "#fafafa",
                                                border: "1px solid #f1f1f1",
                                                fontSize: "14px",
                                                fontWeight: 700,
                                                color: "#333",
                                                fontFamily:
                                                    "'Plus Jakarta Sans',sans-serif",
                                                transition: "all .3s ease",
                                            }}
                                        >
                                            {item}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <style>{`
.technology-icon{
    width:70px;
    height:70px;

    display:flex;
    align-items:center;
    justify-content:center;

    border-radius:20px;

    background:linear-gradient(
        135deg,
        #E8212A,
        #ff646b
    );

    color:#fff;
    font-size:30px;

    margin-bottom:20px;

    box-shadow:
        0 15px 35px rgba(232,33,42,.25);

    transition:.4s ease;
}

.technology-card:hover .technology-icon{
    transform:
        translateY(-8px)
        rotate(-6deg);

    box-shadow:
        0 25px 50px rgba(232,33,42,.35);
}
                @keyframes fadeUp{
                    from{
                        opacity:0;
                        transform:translateY(50px);
                    }
                    to{
                        opacity:1;
                        transform:translateY(0);
                    }
                }

                @keyframes pulseGlow{
                    0%,100%{
                        transform:translateY(-50%) scale(1);
                    }
                    50%{
                        transform:translateY(-50%) scale(1.1);
                    }
                }

                @keyframes pulseDot{
                    0%,100%{
                        transform:scale(1);
                        opacity:1;
                    }
                    50%{
                        transform:scale(1.4);
                        opacity:.6;
                    }
                }

                @keyframes floatBox{
                    0%,100%{
                        transform:translateY(0px);
                    }
                    50%{
                        transform:translateY(-10px);
                    }
                }

                @media(max-width:992px){

                    .tech-grid{
                        grid-template-columns:1fr !important;
                    }

                }

                @media(max-width:768px){

                    section{
                        padding:90px 20px !important;
                    }

                    h2{
                        font-size:44px !important;
                    }

                }

                @media(max-width:560px){

                    h2{
                        font-size:36px !important;
                    }

                }

            `}</style>
            </section>
        </>
    );
};

export default MobileTechStack;